/* Edits the state whenever xmlFile event triggers */

export function xmlTargetFetchHasErrored(state = false, action) {
	switch (action.type) {
	case 'XML_TARGET_LOAD_FAILED':
		return action.hasErrored;
	default:
		return state;
	}
}
export function xmlTargetFetchIsLoading(state = false, action) {
	switch (action.type) {
	case 'XML_TARGET_ISLOADING':
		return action.isLoading;
	default:
		return state;
	}
}
export function xmlTargetFile(state = [], action) {
	switch (action.type) {
	case 'XML_TARGET_LOADED':
		return action.file;
	default:
		return state;
	}
}
